import type { StyleData } from "@ui5/webcomponents-base/dist/types.js";
import { registerThemePropertiesLoader } from "@ui5/webcomponents-base/dist/asset-registries/Themes.js";

import defaultThemeBase from "@ui5/webcomponents-theming/dist/generated/themes/sap_horizon/parameters-bundle.css.js";
import defaultTheme from "./sap_horizon/parameters-bundle.css.js";

registerThemePropertiesLoader("@ui5/webcomponents-theming", "sap_horizon", async () => defaultThemeBase);
registerThemePropertiesLoader("@udex/web-components", "sap_horizon", async () => defaultTheme);

const styleData: StyleData = {packageName:"@udex/web-components",fileName:"themes/DatePickerPopover.css.ts",content:`.udex-date-picker__popover{--udex-dropdown-border-width: 0;--udex-dropdown-pane-max-width: fit-content}@media (width < 640px){.udex-date-picker__popover{--udex-dropdown-pane-min-width-xs: fit-content;--udex-dropdown-pane-max-width-xs: fit-content}}
`};
export default styleData;
	